
  <div class="" *ngIf="viewBooking!=null">


    <div class="" *ngIf="viewMode==viewBookingViewModeEnum.Default">
      <div class="col-md-12 booking-status m-0 p-0 row">

        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center" *ngIf="viewBooking.paid==0">
          <div class="booking-number">{{viewBooking.bookingNumber}}</div>
          <!-- <div class="booking-detials d-flex ">{{ 'FullyPaid' | translate }} <span>{{viewBooking.grandTotal}}$</span></div> -->
        </div>
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center" *ngIf="viewBooking.paid>0">
          <div class="booking-number">{{viewBooking.bookingNumber}}</div>
          <!--  <div class="booking-detials d-flex ">{{ 'OutstandingBalance' | translate }} <span>{{viewBooking.outStandingBalance}}$</span></div> -->
        </div>
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center" *ngIf="viewBooking.paid<0">
          <div class="booking-number">{{viewBooking.bookingNumber}}</div>
          <!--  <div class="booking-detials d-flex ">{{ 'OutstandingBalance' | translate }}<span>{{viewBooking.outStandingBalance}}$</span></div> -->
        </div>

        <div class="col-lg-8 col-md-8 col-12 booking-info-p">
          <div class="booking-info align-items-center row">
            <div class="col-lg-6 col-md-5 col-12 d-flex align-items-center justify-content-start">
              <div class="">
                <button  class="booking-actions-btn" mat-button [matMenuTriggerFor]="bookingActions">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu class="booking-actions" #bookingActions="matMenu">
                  <ng-container *ngFor="let action of workflowInstancePossibleAction">
                    <container-element [ngSwitch]="action.workflowUserActionID">

                      <button *ngSwitchCase="workflowInstancePossibleActionEnum.ReservationCancelConfirmed"
                        class="rounded-circle" (click)="openCancel()" mat-menu-item>
                        <div placement="right" ngbPopover="{{ 'CancelBooking' | translate }}" triggers="mouseenter:mouseleave" container="body"><mat-icon>close</mat-icon></div>

                      </button>
                      <button *ngSwitchCase="workflowInstancePossibleActionEnum.ReservationUpdateConfirmed"
                        class="rounded-circle" (click)="openModificationType()" mat-menu-item>
                        <div  placement="right" ngbPopover="{{ 'ModifiyBooking' | translate }}" triggers="mouseenter:mouseleave" container="body"><mat-icon>edit</mat-icon></div>
                      </button>
                      <button *ngSwitchCase="workflowInstancePossibleActionEnum.ReservationExtendContract"
                        class="rounded-circle" (click)="openExtend()" mat-menu-item>
                        <div  placement="right" ngbPopover="{{ 'ExtendRentalTime' | translate }}" triggers="mouseenter:mouseleave" container="body"><mat-icon>alarm</mat-icon></div>
                      </button>
                    </container-element>
                  </ng-container>

                  <button *ngIf="viewBooking.caseStateID==vehicleReservationState.Returned||viewBooking.caseStateID==vehicleReservationState.Closed||viewBooking.caseStateID==vehicleReservationState.Pickedup" (click)="downloadContract()" class="rounded-circle" mat-menu-item>
                    <div  placement="right" ngbPopover="{{ 'PrintContract' | translate }}" triggers="mouseenter:mouseleave" container="body"><mat-icon>print</mat-icon></div>
                  </button>


                  <button class="rounded-circle" (click)="openAddReview()"  mat-menu-item *ngIf="viewBooking.caseStateID==vehicleReservationState.Returned||viewBooking.caseStateID==vehicleReservationState.Closed">
                    <div  placement="right" ngbPopover="{{ 'AddReviews' | translate }}" triggers="mouseenter:mouseleave" container="body"><mat-icon>star</mat-icon></div>
                  </button>
                </mat-menu>
              </div>
              <div class="booking-duration-mobile">
                <span class="booking-duration">{{viewBooking.durationUnitName | translate}}</span>
              </div>
            </div>

            <div class="col-lg-2 col-md-2 col-12 booking-note"></div>
            <div class="col-lg-4 col-xl-3 col-md-5 col-12 d-flex align-items-center justify-content-end booking-status-mobile"><span class="booking-header-status">
            <div *ngIf="viewBooking.caseStatus==11">
              {{ 'Closed' | translate }}
            </div>
            <div *ngIf="viewBooking.caseStatus !=11">
              {{viewBooking.caseStatus | translate }}
            </div>


            </span></div>
          </div>
        </div>
      </div>


        <div class="max-page-width row">
          <div class="col-lg-9 col-md-8 pr-0  left-side">
            <!--View Booked Car-->
            <div class="mt-3">
              <booking-vehicle-type [pageType]="4"></booking-vehicle-type>

            </div>
            <!-- <view-booked-car></view-booked-car>  -->
            <!--View Booked Details-->
            <div class="row ">
              <div class="col-lg-9">
                <view-booking-details></view-booking-details>
              </div>
              <div class="col-lg-3 ads pl-lg-0 align-items-start">
                <div class="supplier-box">
                  <div class="d-flex mb-2">
                    <span class="text-blue  l-35 mr-auto">{{ 'AgencyInformation' | translate }}</span>
                      <input class="agency-box-icon zoom" (click)="openAgencyMap()" type="image" src="assets/img/googleMapIcon.svg" >
                  </div>



                  <div class="mt-1 d-flex text-left">
                    <div class="mr-3"><fa-icon class="fa-s" [icon]="faMapMarkerAlt"></fa-icon></div>
                    <div class="">{{viewBooking.fromAgencyName}} | {{viewBooking.summaryChargePickUpLocationAddress}}</div>
                  </div>
                  <div class="mt-1 d-flex text-left" >
                    <div class="mr-3"><mat-icon>mail</mat-icon></div>
                    <div>{{viewBooking.fromAgencyEmail}}</div>
                  </div>
                  <div class="mt-1 d-flex text-left" >
                    <div class="mr-3"><mat-icon>stay_primary_portrait</mat-icon></div>
                    <div class="agency-phone">{{viewBooking.fromAgencyPhone}}</div>
                  </div>



                </div>

                <div class="Ads-box" *ngIf="campaignsReservationCaseModel!=null">
                  <img [src]="attachmnetService.getImageLink(campaignsReservationCaseModel.originalCampaignID,AttachmentScopesEnum.Campaign,AttachmentTypeEnum.MemberShipBanners)"
                  (click)="openCampaignLandingPage()" class="img-fluid"
                  >
                  <div class="p-2">
                    <div class="campaign-title mb-1">{{campaignsReservationCaseModel.campaignName}}</div>
                    <div *ngIf="campaignsReservationCaseModel.discount!=null"><b>{{ 'Discount' | translate}}:</b> {{(campaignsReservationCaseModel.discount) | number : '1.2-2'}}%  {{campaignsReservationCaseModel.discountScopeName}}</div>
                    <div><strong>{{'ExpiryDate' | translate}}:</strong> {{campaignsReservationCaseModel.endDateFormated}}</div>
                  <ng-container  *ngFor="let service of campaignsReservationCaseModel.campaignAdditionalServices">
                    <div *ngIf="service.quantity!=null">
                      - {{service.serviceName}} / {{'Quantity' | translate}}: {{service.quantity}}
                    </div>
                    <div *ngIf="service.quantity==null">
                      - {{service.serviceName}}
                    </div>
                  </ng-container>

                  <ng-container  *ngFor="let campaign of campaignsReservationCaseModel.campaignFreePolicies">
                    <div >
                   - {{campaign.policyTypeName}}
                  </div>
                </ng-container>

                  </div>
                </div>
                <div class="download-box">
                  <p>{{ 'DownloadAPP' | translate }}</p>
                  <div class="d-flex">
                    <a target="_blank" href="#"><img _ngcontent-lmt-c242="" src="assets/img/appStore1.svg" class="mr-1"></a>
                    <a target="_blank" href="#"><img _ngcontent-lmt-c242="" src="assets/img/googlePlay1.svg"></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 pr-0  mb-4 right-side">
            <!-- CountDown -->
            <!-- <div *ngIf="showCountDown" class="countdown countdown-view-booking">
              <div class="countdown-title">Your Trip Starts In</div>
              <div class="countdown-number">
                <countdown #countdown [config]="{leftTime: viewBooking.countDownInSec}" (finished)="finishTest()">
                  $!h!$!m!$!s!</countdown>
              </div>
            </div> -->

            <!-- MyCar -->
            <view-my-car [reservationCaseResult]="reservationCaseResult"></view-my-car>
            <!-- ChargeSummery -->
            <!-- <charge-summary></charge-summary> -->
            <charge-summary-view-booking [reservationCaseData]="reservationCaseResultData" [viewBookingViewMode]="viewMode" ></charge-summary-view-booking>
          </div>
        </div>


    </div>

    <div class="row mr-0" *ngIf="viewMode==viewBookingViewModeEnum.Extend">
    <div class="col-md-12 booking-status p-0 m-0 row">
      <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center">
        <div class="booking-number">
          {{viewBooking.bookingNumber}}
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-12 d-flex justify-content-center booking-info">
        <div class="booking-number">
        {{  'ExtendRentalTime' | translate  }}
        </div>
      </div>
    </div>
      <div class="max-page-width">
        <extend-rental-time-modal (onCancel)="resetViewMode(viewBookingViewModeEnum.Extend)"></extend-rental-time-modal>
      </div>
    </div>

    <ng-container *ngIf="viewMode==viewBookingViewModeEnum.AddRemoveExtras">
      <div >
        <div class="booking-status col-md-12 p-0 m-0 row">
          <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center">
            <div class="booking-number">
              {{viewBooking.bookingNumber}}
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-12 d-flex justify-content-center booking-info">
            <div class="booking-number">
            {{  'UpdateBookingExtra' | translate  }}
            </div>
          </div>
        </div>
        <div class="max-page-width">
          <add-remove-extras-modal (onCancel)="resetViewMode(viewBookingViewModeEnum.AddRemoveExtras)"></add-remove-extras-modal>
        </div>
      </div>
    </ng-container>


    <div class="row" *ngIf="viewMode==viewBookingViewModeEnum.ModifyPickUp">
      <div class="booking-status col-md-12 p-0 m-0 row">
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center">
          <div class="booking-number">
            {{viewBooking.bookingNumber}}
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-12 d-flex justify-content-center booking-info">
          <div class="booking-number">
          {{  'UpdateBookingDate' | translate  }}
          </div>
        </div>
      </div>
      <div class="max-page-width">
         <modify-pickup-modal (onCancel)="resetViewMode()"></modify-pickup-modal>
      </div>
    </div>

    <div class="row" *ngIf="viewMode==viewBookingViewModeEnum.UpdateDriverInfo">
      <div class="booking-status col-md-12 p-0 m-0 row">
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-center">
          <div class="booking-number">
            {{viewBooking.bookingNumber}}
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-12 d-flex justify-content-center booking-info">
          <div class="booking-number">
            {{  'UpdateDriverInformation' | translate  }}
          </div>
        </div>
      </div>
      <div class="max-page-width">
        <update-additional-modal (onCancel)="resetViewMode()"></update-additional-modal>
      </div>
    </div>


  </div>




